import { useEffect, useState } from "react";
import { Modal, Form, Input, Select, InputNumber, Typography, Button, Row, Col } from "antd";
import { callParticipantByPhone, callReserveTicket } from "../../../../services/participantsService";
import { formatPhoneNumber, formatTicketNumber, formatWhatsMessageDate, showNotificationTopEnd, showSuccessModal } from "../../../../util/utils";
import { EnvironmentOutlined, PhoneOutlined, UserOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import "./ModalPersonalInfo.css";

const { Option } = Select;
const { Title, Text } = Typography;

export default function ModalPersonalInfo(props) {
    const { visible, onClose, data, selectedTickets, handleRefresh, handleCleanSelectedTickets } = props;
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const { executeRecaptcha } = useGoogleReCaptcha();


    useEffect(() => {
        if (visible) {
            form.resetFields();
        }
    }, [visible, form]);


    const onSearchParticipant = async () => {
        const { lada, phone } = form.getFieldsValue();

        if (!lada || !phone) {
            return;
        }

        if (phone.toString().length === 10) {
            if (!executeRecaptcha) {
                console.warn("reCAPTCHA no está listo");
                return;
            }

            setLoading(true);
            const token = await executeRecaptcha('search_participant');

            const response = await callParticipantByPhone(lada, phone, token);
            if (response?.status === 200) {
                form.setFieldsValue(response.data);
            } else {
                const fieldsToReset = Object.keys(form.getFieldsValue()).filter(
                    (name) => name !== "phone" && name !== "lada"
                );
                form.resetFields(fieldsToReset);
            }
            setLoading(false);
        } else {
            const fieldsToReset = Object.keys(form.getFieldsValue()).filter(
                (name) => name !== "phone" && name !== "lada"
            );
            form.resetFields(fieldsToReset);
        }
    }


    const handleSubmit = async () => {

        try {
            const values = await form.validateFields();

            if (!executeRecaptcha) {
                console.warn("reCAPTCHA no está listo");
                return;
            }

            setLoading(true);

            // Abrimos una pestaña vacía inmediatamente (esto no se bloquea)
            const newWindow = window.open('', '_blank');

            const token = await executeRecaptcha('reserve_tickets');

            const participante = {
                recaptchaToken: token,
                name: values.name.toUpperCase(),
                lastName: values.lastName.toUpperCase(),
                state: values.state,
                phone: values.phone,
                lada: values.lada,
                // whatsappOptIn: values.whatsappOptIn,
                idLotto: data.lottoId,
                tickets: selectedTickets
            };

            const response = await callReserveTicket(participante);
            if (response?.status === 200) {

                const whatsAppUrl = generateWhatsAppLink(participante, data, response);
                newWindow.location.href = whatsAppUrl;

                form.resetFields();
                handleRefresh();
                handleCleanSelectedTickets();

                showSuccessModal("success", "Boletos reservados correctamente", "Ahora confirma tu reserva enviando el siguiente mensaje por WhatsApp");
                onClose();

            } else {
                newWindow.close();
                if (response?.status === 400) {
                    showNotificationTopEnd("error", response?.data?.message);
                } else {
                    showNotificationTopEnd("error", "No fue posible reservar los boletos, por favor inténtalo más tarde");
                }
            }

        } catch (error) {
            showNotificationTopEnd("error", "Ingresa correctamente los datos");
        } finally {
            setLoading(false);
        }
    };


    const generateWhatsAppLink = (participant, data, response) => {
        //const phoneNumber = participant.lada + participant.phone;
        const phoneDestino = response.data.message.replace(/\D/g, '');

        console.log("participantData: ", participant);
        console.log("lottoData: ", data);
        console.log("response: ", response);

        const wavingHand = "\u{1F44B}"; // 👋
        const trophy = "\u{1F3C6}";     // 🏆
        const ticketEmoji = "\u{1F3AB}";// 🎟️
        const calendar = "\u{1F4C5}";   // 📅
        const moneyBag = "\u{1F4B5}";   // 💵
        const checkMark = "\u{2705}";   // ✅
        const clover = "\u{1F340}";     // 🍀

        // Construimos el string con Template Literals para mantener el orden
        const message = `¡Hola ${wavingHand}! Reservé boletos para participar en *${data.title.toUpperCase()}*.
${trophy} *${data.subtitle}*

He reservado ${participant.tickets.length} boleto(s):
${ticketEmoji} ${participant.tickets.map(t => formatTicketNumber(t.ticketNumber, data.ticketAmount)).join(', ')}

${calendar} *Fecha del sorteo:* ${formatWhatsMessageDate(data.lottoDate)}
${moneyBag} El total por *${participant.tickets.length} boleto(s)* es: *$ ${participant.tickets.length * data.ticketPrice} MXN*

*Nombre:* ${participant.name.toUpperCase()} ${participant.lastName.toUpperCase()}
*Celular:* +${participant.lada} ${formatPhoneNumber(participant.phone)}

*Cuentas de Pago:* www.rifasgranfamiliagdl.com.mx/pagos

Recuerda que tu pago asegura tu participación ${checkMark}
El siguiente paso es enviar tu comprobante de pago por este chat.
¡Mucha suerte! ${clover}`;

        // El truco está en encodeURIComponent para los emojis y saltos de línea
        const encodedMessage = encodeURIComponent(message);

        return `https://api.whatsapp.com/send?phone=${phoneDestino}&text=${encodedMessage}`;
    };


    return (
        <>
            <Modal
                open={visible}
                onCancel={onClose}
                footer={null}
                centered
                destroyOnHidden
            >
                <Form form={form} layout="vertical">
                    <div style={{ textAlign: "center", marginBottom: "20px" }}>
                        <Title level={3}>Ingresa tus datos y haz clic en “Apartar”</Title>
                        <Title level={4} style={{ color: "#a63827" }}>{`${selectedTickets.length} Boletos por $${selectedTickets.length * data.ticketPrice} MXN`}</Title>
                    </div>

                    <Row gutter={8}>
                        <Col xs={24} sm={7} md={7} lg={7}>
                            <Form.Item
                                name="lada"
                                rules={[{ required: true, message: "Selecciona la lada" }]}
                            >
                                <Select size="large" style={{ width: "100%" }} placeholder="Lada" prefix={<PhoneOutlined style={{ fontSize: 16 }} />} onChange={onSearchParticipant}>
                                    <Option value="52"><span className="fi fi-mx" style={{ marginLeft: 4 }}></span> +52</Option>
                                    <Option value="1"><span className="fi fi-us" style={{ marginLeft: 4 }}></span> +1</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={17} md={17} lg={17}>
                            <Form.Item
                                name="phone"
                                rules={[
                                    { required: true, message: "Por favor ingresa tu teléfono" },
                                    { pattern: /^\d{10}$/, message: "El teléfono debe contener exactamente 10 dígitos" }
                                ]}
                            >
                                <InputNumber size="large" style={{ width: '100%' }} placeholder="INGRESA TU NÚMERO DE WHATSAPP (10 DÍGITOS)" onChange={onSearchParticipant} prefix={<WhatsAppOutlined style={{ fontSize: 16 }} />} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item
                        name="name"
                        getValueFromEvent={(e) => e.target.value.toUpperCase()}
                        rules={[{ required: true, message: "Por favor ingresa tu nombre" },
                        { min: 2, message: "El nombre debe tener mas de 1 caracter" },
                        { max: 100, message: "El nombre debe tener menos de 100 caracteres" }]}
                    >
                        <Input style={{ textTransform: "uppercase" }} size="large" placeholder="INGRESA TU(S) NOMBRE(S)" prefix={<UserOutlined style={{ fontSize: 16 }} />} />
                    </Form.Item>

                    <Form.Item
                        name="lastName"
                        getValueFromEvent={(e) => e.target.value.toUpperCase()}
                        rules={[{ required: true, message: "Por favor ingresa tus apellidos" },
                        { min: 2, message: "Los apellidos deben tener mas de 1 caracter" },
                        { max: 100, message: "Los apellidos deben tener menos de 100 caracteres" }]}
                    >
                        <Input style={{ textTransform: "uppercase" }} size="large" placeholder="INGRESA TUS APELLIDOS" prefix={<UserOutlined style={{ fontSize: 16 }} />} />
                    </Form.Item>

                    <Form.Item
                        name="state"
                        rules={[{ required: true, message: "Selecciona tu estado" }]}
                    >
                        <Select size="large" placeholder="SELECCIONA TU ESTADO" style={{ width: "100%" }} prefix={<EnvironmentOutlined style={{ fontSize: 16 }} />} getPopupContainer={triggerNode => triggerNode.parentNode}>
                            <Option value="AGUASCALIENTES">AGUASCALIENTES</Option>
                            <Option value="BAJA CALIFORNIA">BAJA CALIFORNIA</Option>
                            <Option value="BAJA CALIFORNIA SUR">BAJA CALIFORNIA SUR</Option>
                            <Option value="CAMPECHE">CAMPECHE</Option>
                            <Option value="CHIAPAS">CHIAPAS</Option>
                            <Option value="CHIHUAHUA">CHIHUAHUA</Option>
                            <Option value="CIUDAD DE MÉXICO">CIUDAD DE MÉXICO</Option>
                            <Option value="COAHUILA">COAHUILA</Option>
                            <Option value="COLIMA">COLIMA</Option>
                            <Option value="DURANGO">DURANGO</Option>
                            <Option value="ESTADO DE MÉXICO">ESTADO DE MÉXICO</Option>
                            <Option value="GUANAJUATO">GUANAJUATO</Option>
                            <Option value="GUERRERO">GUERRERO</Option>
                            <Option value="HIDALGO">HIDALGO</Option>
                            <Option value="JALISCO">JALISCO</Option>
                            <Option value="MICHOACÁN">MICHOACÁN</Option>
                            <Option value="MORELOS">MORELOS</Option>
                            <Option value="NAYARIT">NAYARIT</Option>
                            <Option value="NUEVO LEÓN">NUEVO LEÓN</Option>
                            <Option value="OAXACA">OAXACA</Option>
                            <Option value="PUEBLA">PUEBLA</Option>
                            <Option value="QUERÉTARO">QUERÉTARO</Option>
                            <Option value="QUINTANA ROO">QUINTANA ROO</Option>
                            <Option value="SAN LUIS POTOSÍ">SAN LUIS POTOSÍ</Option>
                            <Option value="SINALOA">SINALOA</Option>
                            <Option value="SONORA">SONORA</Option>
                            <Option value="TABASCO">TABASCO</Option>
                            <Option value="TAMAULIPAS">TAMAULIPAS</Option>
                            <Option value="TLAXCALA">TLAXCALA</Option>
                            <Option value="VERACRUZ">VERACRUZ</Option>
                            <Option value="YUCATÁN">YUCATÁN</Option>
                            <Option value="ZACATECAS">ZACATECAS</Option>
                        </Select>
                    </Form.Item>

                    {/* <Form.Item
                        name="whatsappOptIn"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error("Debes aceptar recibir el mensaje de confirmación por WhatsApp para continuar con tu compra"))
                            }
                        ]}
                    >
                        <Checkbox style={{ fontSize: '14px', textAlign: 'left' }}>
                            Acepto recibir mensajes de <span style={{ color: '#25D366', fontWeight: 'bold' }}>WhatsApp</span> con la confirmación de mis boletos y detalles del sorteo.
                        </Checkbox>
                    </Form.Item> */}
                    <div style={{ textAlign: "center" }}>
                        <Text style={{ color: 'rgba(0,0,0,0.45)' }} strong>* Asegúrate de que tu número de WhatsApp sea correcto antes de continuar.</Text>
                    </div>

                    <Form.Item>
                        <Button type="primary" size="large" className="apartar-button" onClick={handleSubmit} loading={loading} block>
                            ¡Apartar Ahora!
                        </Button>
                    </Form.Item>
                </Form>

            </Modal >
        </>
    );
}